import api from './api';

export const funeralStoreService = {
    admin: {
        products: {
            getAll: async (params = {}) => {
                const queryParams = new URLSearchParams();
                Object.entries(params).forEach(([key, value]) => {
                    if (value !== undefined && value !== null && value !== '') {
                        queryParams.append(key, value);
                    }
                });
                const queryStr = queryParams.toString() ? `?${queryParams.toString()}` : '';
                const response = await api.get(`/admin/funeral-store/products${queryStr}`);
                return response.data;
            },
            create: async (data) => {
                const response = await api.post('/admin/funeral-store/products', data);
                return response.data;
            },
            update: async (id, data) => {
                const response = await api.put(`/admin/funeral-store/products/${id}`, data);
                return response.data;
            },
            delete: async (id) => {
                const response = await api.delete(`/admin/funeral-store/products/${id}`);
                return response.data;
            }
        },
        collections: {
            getAll: async (params = {}) => {
                const queryParams = new URLSearchParams();
                Object.entries(params).forEach(([key, value]) => {
                    if (value !== undefined && value !== null && value !== '') {
                        queryParams.append(key, value);
                    }
                });
                const queryStr = queryParams.toString() ? `?${queryParams.toString()}` : '';
                const response = await api.get(`/admin/funeral-store/collections${queryStr}`);
                return response.data;
            },
            create: async (data) => {
                const response = await api.post('/admin/funeral-store/collections', data);
                return response.data;
            },
            update: async (id, data) => {
                const response = await api.put(`/admin/funeral-store/collections/${id}`, data);
                return response.data;
            },
            delete: async (id) => {
                const response = await api.delete(`/admin/funeral-store/collections/${id}`);
                return response.data;
            }
        }
    },
    reseller: {
        getProducts: async (params = {}) => {
            const response = await api.get('/reseller/funeral-store/products', { params });
            return response.data;
        },
        getProductById: async (id) => {
            const response = await api.get(`/reseller/funeral-store/products/${id}`);
            return response.data;
        },
        getCollections: async () => {
            const response = await api.get('/reseller/funeral-store/collections');
            return response.data;
        },
        getAddress: async () => {
            const response = await api.get('/reseller/profile/address');
            return response.data;
        }
    }
};
